import Images from "../utils/Images";

/** Options for Event & Media Sales (aligned with consumer MediaEvents). Add more as new services go live. */
export const mediaEventOptions = [
  {
    key: "conference-trade-mission",
    title: "Conf. & Trade Mission",
    subtitle: "Conf. & Trade Mission Coverage",
    image: Images.conference_illustrator,
    link: "/event-media-sales/conference-trade-mission",
  },
  {
    key: "event",
    title: "Events",
    subtitle: "Events Coverage and Seminars",
    image: Images.events_illustrator,
    link: "/event-media-sales/events",
  },
  {
    key: "tour",
    title: "Tour Packages",
    subtitle: "Affordable Holiday Tour Packages",
    image: Images.tour_packages_illustrator,
    // link can be added when service goes live
  },
];
